export default __webpack_public_path__ + "static/media/Y16.4627724d.jpg";